import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import "../preloading.css";
import Select from 'react-select';

const LateReportWeekly = () => {
  // ✅ Get current week in ISO format (YYYY-Wxx)
  const getCurrentWeek = () => {
    const today = new Date();
    const onejan = new Date(today.getFullYear(), 0, 1);
    const days = Math.floor((today - onejan) / (24 * 60 * 60 * 1000));
    const week = Math.ceil((days + onejan.getDay() + 1) / 7);
    return `${today.getFullYear()}-W${String(week).padStart(2, "0")}`;
  };

  const [filters, setFilters] = useState({
    start_date: getCurrentWeek(),
    dept_id: "0",
    action_type: "Fetch",
  });

  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Fetch Departments
  const fetchDepartments = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/showdepartment", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
      const deptData =
        res.data.departments || res.data.data || (Array.isArray(res.data) ? res.data : []);
      setDepartments(deptData);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load departments");
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  // ✅ Fetch Weekly Report
  const handleSubmit = async (e) => {
    e.preventDefault();
    // block repeat clicks while a request is already running
    if (loadingRef.current) return;
    loadingRef.current = true;
    setLoading(true);
    try {
      const res = await axios.post(
        API_BASE_URL + "/weekly_late_report",
        {
          start_date: filters.start_date,
          dept_id: filters.dept_id,
          action_type: filters.action_type,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );
      setRecords(res.data.records || []);
      setCurrentPage(1);
      toast.success("Weekly late report loaded!", {
        position: "bottom-right",
        theme: "colored",
        toastId: "weekly-late-success",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error fetching weekly late report", { toastId: "weekly-late-error" });
    } finally {
      loadingRef.current = false;
      setLoading(false);
    }
  };

  // ✅ Pagination + Filter
  const filteredItems = records.filter((item) =>
    `${item.employee_id}${item.employee_name}${item.department}${item.total_late_hours}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <div className="container-fluid mt-4">

        {/* Filter Form */}
        <div className="card shadow-sm mb-4">
          <h6 className="card-header d-flex align-items-center" style={{ color: "#1d3a8a", fontWeight: 600 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
              <path fillRule="evenodd" d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.017-1.694a.5.5 0 1 1 .858.257z"/>
              <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
              <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
            </svg>
            Weekly Late Report Summary
          </h6>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">
                <div className="col-md-3">
                  <label htmlFor="start_date">Select Week</label>
                  <input
                    type="week"
                    className="form-control"
                    style={{ height: "38px" }}
                    name="start_date"
                    value={filters.start_date}
                    onChange={handleInput}
                    required
                  />
                </div>

                <div className="col-md-3">
                  <label htmlFor="dept_id">Department</label>
                   <Select
    name="dept_id"
    
    value={
      departments
        .map((dept) => ({
          value: dept.department_id || dept.id,
          label: dept.department_name,
        }))
        .find((d) => d.value === filters.dept_id) || null
    }
    onChange={(selected) =>
      handleInput({
        target: {
          name: "dept_id",
          value: selected ? selected.value : "0", // same as All Department
        },
      })
    }
    options={departments.map((dept) => ({
      value: dept.department_id || dept.id,
      label: dept.department_name,
    }))}
    isClearable
    placeholder="All Department"
    className="basic-single"
  />
                </div>

                <div className="col-md-auto">
                  <button type="submit" className="btn btn-primary btn-sm" style={{ height: "38px" }} disabled={loading}>
                    {loading ? "Loading..." : "Get"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Table */}
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-2 align-items-center">
              <div className="d-flex align-items-center gap-2">
                <DownloadButtons data={filteredItems} filename="Weekly_Late_Report" />
              </div>

              <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                <EntriesSelector
                  setEntriesPerPage={setEntriesPerPage}
                  setCurrentPage={setCurrentPage}
                />
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  style={{ width: "200px" }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead style={{ backgroundColor: "#7d858369" }}>
                    <tr>
                      <th>Employee ID</th>
                      <th>Employee Name</th>
                      <th>Department</th>
                      <th>Total Late Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.employee_id}</td>
                          <td>{row.employee_name}</td>
                          <td>{row.department}</td>
                          <td>{row.total_late_hours}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-danger fw-bold">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LateReportWeekly;
